<template slot-scope="scope">
  <!-- 处理结果弹窗 -->
  <dialogModel
    :title="result == 2 || result == 1 ? '处理结果' : '撤销'"
    :visible="dialogVisible"
    :footer="result == 2 || result == 3"
    @handleClose="handleClose"
    @handleOk="handleUnderstand"
  >
    <div class="main-body">
      <div v-if="result == 2 || result == 1">
        <div class="result">
          对{{ ProcessingResult.targetName }}的处理结果：
        </div>
        <div class="result-content">
          根据投诉内容，进行核实，确认属实，对{{
            ProcessingResult.type == 1 || ProcessingResult.type == 3
              ? "该公司"
              : "该个人"
          }}进行<span class="result-text">{{ ProcessingResult.resultText }}</span>的处理结果，若有异议请在七天内联系客服。
        </div>
        <div class="result-date">
          <div>{{ ProcessingResult.processTime }}</div>
        </div>
      </div>
      <div v-if="result == 3">
        <div class="cancel">确认撤销该投诉?</div>
      </div>
    </div>
  </dialogModel>
</template>

<script>
export default {
  props: {
    dialogVisible: {},
    result: {},
    ProcessingResult: {}, // 处理结果内容 resultText  时间 processTime
  },
  methods: {
    handleClose() {
      this.$emit("handleClose", this.result);
    },
    handleUnderstand() {
      this.$emit("handleUnderstand", this.result);
    },
  },
};
</script>

<style scoped lang="less">
.main-body {
  min-height: 40px;
}
.result {
  font-size: 14px;
  color: #333333;
  font-weight: 400;
}
.result-content {
  text-indent: 24px;
  font-size: 14px;
  color: #333333;
  font-weight: 400;
  margin-top: 15px;
  line-height: 22px;
  .result-text {
    font-weight: 700;
  }
}
.result-date {
  display: flex;
  justify-content: flex-end;
  margin-top: 50px;
  margin-bottom: 8px;
  font-size: 12px;
  color: #333333;
  font-weight: 400;
}
.cancel {
  text-align: center;
  font-size: 14px;
  color: #333;
  padding: 20px 0;
}
</style>
